import { Link } from "react-router-dom";
import { useLeadDialog } from "../context/LeadDialogContext";
import { useLang } from "../context/LanguageContext";
import { LanguageSwitcher } from "./LanguageSwitcher";

export function Navbar() {
  const lead = useLeadDialog();
  const { t } = useLang();
  return (
    <header data-testid="navbar" className="relative z-30 w-full bg-[#0B1220] border-b border-white/10">
      <div className="px-6 md:px-12 max-w-[1400px] mx-auto flex items-center justify-between h-20">
        <Link to="/" data-testid="navbar-logo" className="flex flex-col leading-none">
          <span className="font-heading text-2xl tracking-tight silver-text leading-none">Advanced Post Graduate</span>
          <span className="text-[10px] uppercase tracking-[0.3em] text-[#5B9DFF] mt-1">Excellence</span>
        </Link>
        <nav className="flex items-center gap-5 md:gap-8">
          <Link to="/" data-testid="navbar-courses-link" className="hidden sm:inline text-sm tracking-wide text-[#C9D2E3] hover:text-white transition-colors">
            {t("nav.courses")}
          </Link>
          <Link to="/blog" data-testid="navbar-blog-link" className="hidden sm:inline text-sm tracking-wide text-[#C9D2E3] hover:text-white transition-colors">
            Blog
          </Link>
          <button
            data-testid="navbar-info-btn"
            onClick={() => lead?.openLead(null, "navbar")}
            className="bg-[#1452F0] text-white hover:bg-[#0E3DC0] transition-colors rounded-sm px-5 py-2.5 text-sm font-medium tracking-wide shadow-[0_0_24px_rgba(20,82,240,0.45)]"
          >
            {t("nav.talk")}
          </button>
          <LanguageSwitcher />
        </nav>
      </div>
    </header>
  );
}
